/**
 * 「今日」を日本時間の日付文字列で返す。
 *
 * UX M-33: `new Date().toISOString().slice(0, 10)` は UTC の日付を返すので、
 * 日本時間の 0〜9 時は前日になる。追記専用の記録（ルールの発効日・照会の送付日・
 * 退職日・開催日など）にその日付が入ったまま残ってしまうのを防ぐため、
 * 「今日」が要る場所は必ずここから取る。
 */
export function todayJst(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}

/** 日付文字列（YYYY-MM-DD）に日数を足す。日本時間に夏時間は無いので、日付の計算だけで済む。 */
export function addDaysJst(date: string, days: number): string {
  return new Date(Date.parse(`${date}T00:00:00Z`) + days * 86_400_000).toISOString().slice(0, 10);
}

/**
 * 過去の日時を「3分前」「2日前」「昨日」のように言う（履歴の「いつ」）。
 * 経過時間から単位を選ぶだけなので、タイムゾーンに依存しない。絶対時刻（日本時間）は
 * useI18n.ts の formatDateTime と並べて出すこと（相対表現だけでは証跡として読めない）。
 */
export function formatRelative(iso: string | Date, lang: "ja" | "en", now: number = Date.now()): string {
  const t = (typeof iso === "string" ? new Date(iso) : iso).getTime();
  const sec = Math.round((t - now) / 1000);
  const rtf = new Intl.RelativeTimeFormat(lang === "ja" ? "ja-JP" : "en-GB", { numeric: "auto" });
  const abs = Math.abs(sec);
  if (abs < 45) return rtf.format(0, "second");
  if (abs < 3600) return rtf.format(Math.round(sec / 60), "minute");
  if (abs < 86_400) return rtf.format(Math.round(sec / 3600), "hour");
  if (abs < 86_400 * 30) return rtf.format(Math.round(sec / 86_400), "day");
  if (abs < 86_400 * 365) return rtf.format(Math.round(sec / (86_400 * 30)), "month");
  return rtf.format(Math.round(sec / (86_400 * 365)), "year");
}
